import React from 'react'
import styled, { css } from 'styled-components'
import { CheckboxWrapper } from './base-checkbox'

type DirectionType = 'column' | 'row'
export interface CheckboxGroupProps {
  children?: React.ReactNode[]
  direction?: DirectionType
  useGrid?: boolean
}


const GridStyle = css`
  column-count: 3;
  column-fill: balance;

  ${({ theme }) => theme.mediaQuery.screenS} {
    column-count: 2;
  }

  ${({ theme }) => theme.mediaQuery.phone} {
    column-count: 1;
  }

  > ${CheckboxWrapper} {
    break-inside: avoid;
    margin-top: 0;
    margin-bottom: ${({ theme }) => theme.space.s16};
  }
`

const BaseStyle = css<{ $direction: DirectionType }>`
  display: flex;
  flex-direction: ${({ $direction }) => $direction};
  flex-wrap: wrap;
`

const StyledCheckboxGroup = styled.div<{
  $direction: DirectionType
  $useGrid: boolean
}>`
  ${({ $useGrid }) => ($useGrid ? GridStyle : BaseStyle)};
  > ${CheckboxWrapper} {
    padding: ${({ theme, $direction }) =>
      $direction === 'row'
        ? `0 ${theme.space.s12} 0 0`
        : `${theme.space.s4} 0`};
  }
`

export const CheckboxGroup = ({
  direction = 'column',
  useGrid = false,
  children,
  ...props
}: CheckboxGroupProps) => (
  <StyledCheckboxGroup {...props} $direction={direction} $useGrid={useGrid}>
    {children}
  </StyledCheckboxGroup>
)
